<style lang="scss" scoped>

.incompleted-irrigations {
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAF0lEQVQIW2NkQAP////3YaRQEGQGuhEAFpIQc5htOmUAAAAASUVORK5CYII=);
}

.disable-links a[href="#"], .disable-links a[href=""] {
    pointer-events: none;
}

.disable-link {
    pointer-events: none !important;
}

</style>

<template>
    <div class="row align-items-center" :class="{ 'disable-links': true }">
        <div class="col-auto">
            <a href="" :title="!profile.allIrrigationsCompleted ? 'Nicht abgeschlossene Entnahme' : ''">
            <span class="avatar text-white bg-green" :class="{ 'incompleted-irrigations-': !profile.allIrrigationsCompleted }">
            <span class="badge" :class="[ isActive(profile) ? 'bg-green': 'bg-' ]" ></span><small v-text="profile.year"></small>
            </span>
            </a>
        </div>
        <div v-if="selectYear && profile.crop.isPerennialCrop" class="col-auto" >
            <select v-model="year" class="form-select">
                <option v-for="option in profileYearList" v-bind:key="option.value" v-bind:value="option.value" v-text="option.label"></option>
            </select>
        </div>
        <div class="col text-truncate">
            <a href="#" class="text-body d-block">{{ profile.label }} ({{ profile.crop.id }}{{ meterToHectare(profile.area) ? ', {} ha'.format(meterToHectare(profile.area)) : '' }})</a>
            <a href="#">
                <small v-if="irrigationLevel" class="d-block text-muted text-truncate mt-n1">
                    Bewässerung bisher {{ irrigationLevel.toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1}) }} mm
                </small>
                <small v-else class="d-block text-muted text-truncate mt-n1">
                    Bisher keine dokumentierte Bewässerung
                </small>
            </a>
        </div>
        <div v-if="profile.crop.isPerennialCrop" class="col-auto" title="Mehrjährige Kultur">
            <svg xmlns="http://www.w3.org/2000/svg"  class="icon text-green" width="24" height="24" viewBox="2 2 20 20" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 13l-2 -2" />
                <path d="M12 12l2 -2" />
                <path d="M12 21v-13" />
                <path d="M9.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4l-.176 -.005" />
            </svg>        
        </div>
        <div v-show="showDetails && !profile.allIrrigationsCompleted" class="col-auto">
            <a href="#" class="list-group-item-actions show" :title="!profile.allIrrigationsCompleted ? 'Nicht abgeschlossene Entnahme' : ''">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-blue" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <rect x="8" y="8" width="12" height="12" rx="2" />
                    <path d="M8 14.5l6.492 -6.492" />
                    <path d="M13.496 20.004l6.504 -6.504l-6.504 6.504z" />
                    <path d="M8.586 19.414l10.827 -10.827" />
                    <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                </svg>
            </a>
        </div>
        <div v-show="showDetails && isSelected(profile)" class="col-auto" title="Ausgewählter Schlag">
            <a href="#" class="list-group-item-actions show">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-green" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>

import * as dayjs from 'dayjs';
import { common } from "@/global";

export default {
    name: 'ProfileItem',
    inject: [
        'state',
        'config'
    ],
    props: {
        profile: {
          type: Object,
          default: null
        },
        showDetails: {
            type: Boolean,
            default: true
        },
        selectYear: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            year: null
        }
    },
    computed: {
        profileYearList: function () {
            return this.profile.crop.vegetationYears.map( function (item) {
                return {
                    label: item.toString(),
                    value: item
                }
            }).reverse();
        },
        irrigationLevel: function () { 
			let totalWithdrawal = null;
            
            // From API for profile list
            if (this.profile.totalWithdrawal && this.profile.totalWithdrawal > 0) {
				totalWithdrawal = this.profile.totalWithdrawal;
			}
            
            // From current withdrawal list
			if (this.totalWithdrawal && this.totalWithdrawal > 0) {
				totalWithdrawal = this.totalWithdrawal;
			}
			
            // Level in mm
            if (totalWithdrawal && totalWithdrawal > 0 && this.profile.area && this.profile.area > 0) {
                return Math.max(0.1, (1000 * totalWithdrawal) /  this.profile.area);
            }
            return null;
        },
		totalWithdrawal: function () { 
            let self = this;
            return this.state.withdrawal.list.reduce( function (sum, withdrawal) {
                if (withdrawal.profileId == self.state.profile.id &&
					withdrawal.countStart > 0 && withdrawal.countEnd > 0  &&
					withdrawal.transferIrrigationLevel == true
					) {
					return sum + Math.max(0, withdrawal.countEnd - withdrawal.countStart);
				}
			}, 0);
		}
    },
    methods: {
        getShortLabel: function (label) {
            return label.substring(0,2);
        },
        meterToHectare: function (value) {
            return common.meterToHectare(value);
        },
        isSelected: function (profile) {
            return (profile.id === this.state.profile.id );
        },
        isActive: function (profile) {           
            return (profile.year === parseInt(dayjs().format('YYYY')));
        }
    },
	watch: {        
        year: function (new_value) {
            this.state.actions.profile.set({year: this.year});
            this.state.actions.profile.setYear(this.year);
        }
    },
	created: function ()  {
        this.year = this.profile.year;
    }
}
</script>